






































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { CosBoardsBoardCodeSummary } from 'ncp-api-supporter';
import ArticleNewBadge from './ArticleNewBadge.vue';

type ArticleType = 'notice' | 'update';
type TabKey = 'all' | ArticleType;
type Article = CosBoardsBoardCodeSummary & { isTopFixed?: boolean };
type TaggedArticle = Article & { type: ArticleType };

@Component({
  components: {
    ArticleNewBadge,
  },
})
export default class ArticleTabList extends Vue {
  @Prop({ required: true })
  private readonly noticeList!: Article[];
  @Prop({ required: true })
  private readonly upgradeList!: Article[];
  @Prop({ required: true })
  private readonly noticeLink!: string;
  @Prop({ required: true })
  private readonly upgradeLink!: string;
  @Prop({ required: true })
  private readonly newsLink!: string;

  private activeTab: TabKey = 'all';

  private get tabs(): { key: TabKey; label: string; link: string }[] {
    return [
      { key: 'all', label: '전체', link: this.newsLink },
      { key: 'notice', label: '공지사항', link: this.noticeLink },
      { key: 'update', label: '업데이트', link: this.upgradeLink },
    ];
  }

  private get activeTabInfo(): { key: TabKey; label: string; link: string } {
    return this.tabs.find(tab => tab.key === this.activeTab) ?? this.tabs[0];
  }

  private get taggedNotices(): TaggedArticle[] {
    return this.noticeList.map(item => ({ ...item, type: 'notice' as const }));
  }

  private get taggedUpdates(): TaggedArticle[] {
    return this.upgradeList.map(item => ({ ...item, type: 'update' as const }));
  }

  private readonly ALL_TAB_MAX_COUNT = 7;

  private get filteredArticles(): TaggedArticle[] {
    if (this.activeTab === 'notice') return this.taggedNotices;
    if (this.activeTab === 'update') return this.taggedUpdates;

    const byPublishedDesc = (a: TaggedArticle, b: TaggedArticle) => b.publishedAt.localeCompare(a.publishedAt);
    const all = [...this.taggedNotices, ...this.taggedUpdates];

    // 출력 순위: 1) 상단고정 공지사항 2) 상단고정 업데이트 3) 일반(시간순)
    const topFixedNotices = all.filter(item => item.isTopFixed && item.type === 'notice').sort(byPublishedDesc);
    const topFixedUpdates = all.filter(item => item.isTopFixed && item.type === 'update').sort(byPublishedDesc);
    const normalArticles = all.filter(item => !item.isTopFixed).sort(byPublishedDesc);

    return [...topFixedNotices, ...topFixedUpdates, ...normalArticles].slice(0, this.ALL_TAB_MAX_COUNT);
  }

  private get commerceSupportUrl() {
    return `${process.env.VUE_APP_COMMERCE_MAIN}/support/board`;
  }

  private openArticleDetail(viewPath: string) {
    window.open(this.commerceSupportUrl + viewPath, '_blank', 'noopener,noreferrer');
  }

  private onViewAllClick() {
    // 전체보기는 현재 활성화된 탭에 해당하는 게시판 링크로 이동한다
    const { link } = this.activeTabInfo;
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  }
}
